webpackJsonp([145982143709654],{

/***/ 437:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Common Energy"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/blog/common-energy-corning-glass-announce-partnership/"},"frontmatter":{"title":"Common Energy & Corning Glass Announce Partnership"}}}]}},"pathContext":{"tag":"Partner"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-partner-0672412cfcfe6fa9d45a.js